export const demicalFormat = (value = 0, fractionDigits = 2) =>
  new Intl.NumberFormat(navigator.language, { minimumFractionDigits: fractionDigits }).format(
    Number(value),
  );
